import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NotProvided } from "@/components/NotProvided";
import type { IAddress } from "@/types/address";
import {
  Card,
  Heading,
  IconButton,
  LabelValue,
  Row,
  Text,
  Tooltip,
} from "@/ui-kit";
import { AddressUtils } from "@/utils/address";

type IProps = {
  address: IAddress;
  onEdit?: () => void;
};

export const AddressDetailsCard = ({ address, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "128px";

  return (
    <Card className="profile-card">
      <Card.Body>
        <Row gap="xl" alignmentVertical="top">
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {t("label.address")}
              </Heading>

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__section">
              <LabelValue
                label={t("label.address")}
                value={
                  address.name ? (
                    AddressUtils.format(address)
                  ) : (
                    <Text size="lg">
                      <NotProvided />
                    </Text>
                  )
                }
                labelWidth={labelWidth}
                canCopy={!!address.name}
              />
            </div>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};
